import React, { FC } from "react";
import { Container } from "../../../../components";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { RapidForm } from "../../../../rapidform";
import { getFormById } from "../../../state/selectors/formSelectors";
import B2BHardwareOnly from "../B2BHardwareOnly/B2BHardwareOnly";

interface StateProps {
    businessDetailsForm: Form;
}

interface BusinessDetailsFormProps extends StateProps {
    onSubmiteBusinessDetails: () => void;
}

const BusinessDetailsForm: FC<BusinessDetailsFormProps> = ({ businessDetailsForm, onSubmiteBusinessDetails }) => {
    const form = (
        <RapidForm
            id={FORM_ID.BUSINESS_DETAILS}
            action={"#"}
            errors={businessDetailsForm.errors}
            values={businessDetailsForm.values}
            visible={businessDetailsForm.visible}
            started={businessDetailsForm.started}
            onSubmit={onSubmiteBusinessDetails}
        >
            <B2BHardwareOnly />
        </RapidForm>
    );

    return (
        <Container className="beta-checkout__section" size="small" whiteBg={true} noPaddingTop>
            {form}
        </Container>
    );
};
const mapStateToProps = (state: RootState): StateProps => ({
    businessDetailsForm: getFormById(state, FORM_ID.BUSINESS_DETAILS),
});

export default connect(mapStateToProps)(BusinessDetailsForm);
